import { render, staticRenderFns } from "./StoreSwiper.vue?vue&type=template&id=323ee2a5&"
import script from "./StoreSwiper.vue?vue&type=script&lang=js&"
export * from "./StoreSwiper.vue?vue&type=script&lang=js&"
import style0 from "./StoreSwiper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports